<template id="workflowTmpl">
	<v-card>
		<v-card-text>
			<v-form ref="workflowFrm" v-model="valid" lazy-validation>
				<v-row no-gutters>
					<v-col cols="12">
						<v-select :items="statusItems" :label="$t('lbl.orgStatusWorkflow')" v-model="newStatus"></v-select>
					</v-col>
					<v-col cols="12">
						<v-btn class="button-main ma-1" v-on:click="saveWorkflowStatus()"><v-icon left dark>cloud_upload</v-icon>{{ $t('btn.save')}}</v-btn>
					</v-col>
				</v-row>	
			</v-form>		
		</v-card-text>
	</v-card>
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

export default {
	i18n,
    data: () => ({
		valid: false,
		statusItems: [],
		newStatus: ''
	}),
	props: ['orgitem', 'prjitem'],
	created() 
	{

	}, 	
	mounted() 
	{
		//=== START LISTEN EVENTS
		events.$on(constants.EVENT_CHANGE_LOCALE, () => {
			this.loadStausItem();	
		});
		events.$on(constants.EVENT_DO_INIT_WORKFLOW, (prjObj) => {
			this.initWorkflow(prjObj);
		});

		this.loadStausItem();
		
		//=== QUALORA FOSSE CARICATO IL PROGETTO PRIMA DELL EVENTO
		this.initWorkflow(this.prjitem);
	},
	destroyed() 
	{
		//=== STOP LISTEN EVENTS
		events.$off(constants.EVENT_CHANGE_LOCALE);
		events.$off(constants.EVENT_DO_INIT_WORKFLOW);
	},
	methods: {
		loadStausItem()
		{
			this.statusItems = [
				{value: constants.PRJ_STATUS_CREATED, text: i18n.t('lbl.status_created')},
				{value: constants.PRJ_STATUS_IN_PROGRESS, text: i18n.t('lbl.status_in_progress')},
				{value: constants.PRJ_STATUS_DONE, text: i18n.t('lbl.status_done')},
			]
		},
		initWorkflow(prjObj)
		{
			this.newStatus = null;
			this.newStatus = this.prjitem.state;
		},
		saveWorkflowStatus()
		{
			if(this.$root.changesNotSavedFlg)
			{
				this.$root.setDialogMsg(i18n.t('err.beforePrjChangeStatusSaveChanges'));
			} 
			else 
			{
				events.$emit(constants.EVENT_DO_CHANGE_PRJ_STATUS, this.newStatus);
			}
		}
	}
}
</script>